module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-google-gtag@4.25.0_gatsby@2.32.13_react-dom@17.0.2_react@17.0.2/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-2K3PH6MKBG"]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
